<template>
  <div class="Convert">
    <div class="info">
      <i class="el-icon-warning"></i>
      <p>Configure convert ratios for Steps, Distance, Calorie, Zocoin, RMB</p>
    </div>
    <div class="main" v-if="convert_info">
      <div class="main_item">
        <el-form ref="form" :inline="true" :model="convert_info.step_info" label-width="150px">
          <el-form-item label="Steps to Meters">
            <el-input size="medium" style="width: 100px"
                      v-model="convert_info.step_info.step_to_meter"></el-input>
          </el-form-item>
          <el-form-item label="Steps to Calories">
            <el-input size="medium" style="width: 100px"
                      v-model="convert_info.step_info.step_to_kcal"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button style="margin-left: 20px" size="medium" type="primary" :disabled="!step_check"
                       @click="onStepSubmit(convert_info.step_info)">Save
            </el-button>
          </el-form-item>
          <el-form-item>
            <p class="note" v-if="step_check">1000 steps converts to {{1000*convert_info.step_info.step_to_meter}}
              meters</p>
            <p class="note" v-if="step_check">1000 steps converts to {{1000*convert_info.step_info.step_to_kcal}}
              kcal </p>
          </el-form-item>
        </el-form>

      </div>

      <div class="main_item">
        <el-form ref="form" :inline="true" :model="convert_info.step_info" label-width="150px">
          <el-form-item label="Steps to Zocoin">
<!--            <el-input size="medium" style="width: 100px"-->
<!--                      v-model="convert_info.balance_info.balance_to_step"></el-input>-->
          <el-input size="medium" style="width: 100px"
                    v-model.number="convert_info.balance_info.step_to_balance"></el-input>
          </el-form-item>
          <el-form-item label="Zocoin to RMB">
            <el-input size="medium" style="width: 100px"
                      v-model.number="convert_info.balance_info.balance_to_cny"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="margin-left: 20px" size="medium" type="primary" :disabled="!balance_check"
                       @click="onBalanceSubmit(convert_info.balance_info)">Save
            </el-button>
          </el-form-item>
          <el-form-item>
            <p class="note" v-if="balance_check">1 Zocoin converts to {{convert_info.balance_info.step_to_balance}}
              steps</p>
            <p class="note" v-if="balance_check">1000 Zocoin converts to
              {{1000/convert_info.balance_info.balance_to_cny}} RMB</p>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </div>
</template>

<script>
  import {getConvertInfo, saveConvertBalance, saveConvertStep} from "@/utils/api";

  export default {
    props: {},
    data: () => {
      return {
        convert_info: false,
        step_check: true,
        balance_check: true
      }
    },
    watch: {
      convert_info: {
        handler(n) {
          this.step_check = !(n.step_info.step_to_meter <= 0 || isNaN(n.step_info.step_to_meter) || n.step_info.step_to_kcal <= 0 || isNaN(n.step_info.step_to_kcal));
          this.balance_check = !(n.balance_info.step_to_balance <= 0 || isNaN(n.balance_info.step_to_balance) || n.balance_info.balance_to_cny <= 0 || isNaN(n.balance_info.balance_to_cny));
        },
        deep: true
      }
    },
    methods: {
      onStepSubmit(info) {
        saveConvertStep(info.step_to_meter, info.step_to_kcal).then(res => {
          if (res.errcode === 0) {
            this.$message.success('Saved');
            getConvertInfo().then(res => {
              this.convert_info = res.convert_info
            })
          } else {
            this.$message.error('Error')
          }
        })

      },
      onBalanceSubmit(info) {
        saveConvertBalance(info.step_to_balance, info.balance_to_cny).then(res => {
          if (res.errcode === 0) {
            this.$message.success('Saved');
            getConvertInfo().then(res => {
              this.convert_info = res.convert_info
            })
          } else {
            this.$message.error('Error')
          }

        })
      },
    },
    beforeMount() {
      getConvertInfo().then(res => {
        this.convert_info = res.convert_info
      })
    }
  };
</script>

<style lang="scss" scoped>
  @import "Convert";
</style>